import { createFileRoute } from '@tanstack/react-router';
import { AuthGuard } from 'src/features/auth/components/guards/auth-guard';
import { Layout } from 'src/layout/main-layout';

export const Route = createFileRoute('/_layout')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AuthGuard>
      <Layout />
    </AuthGuard>
  );
}
